import React, { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Typography from '@material-ui/core/Typography';
import { FORM_FIELDS_MAP } from 'features/sendouts/components/drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import strings from 'strings';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import { REQUIRED_VALIDATION } from 'UI/utils';

import { getTimezones } from './TimezoneSelector.utils';

const STRINGS = strings.sendouts.form;

const TIMEZONE_OPTIONS = getTimezones(); // TODO: once the new api is ready, we should get the timezones from the backend instead of using a static list

export const TimezoneSelector = () => {
  const { control } = useFormContext();

  const handleOnChange = useCallback(([, value]) => value, []);

  return (
    <Controller
      name={FORM_FIELDS_MAP.InterviewTimezone.key}
      control={control}
      rules={REQUIRED_VALIDATION}
      defaultValue={null}
      onChange={handleOnChange}
      onChangeName="onSelect"
      valueName="selectedValue"
      as={
        <AutocompleteSelect
          placeholder={STRINGS.labels.timezone}
          options={TIMEZONE_OPTIONS}
          renderOption={record => (
            <Typography>
              {record.title} <br />
              <Typography variant="caption" component="span" color="textSecondary">
                ({record.offset_title})
              </Typography>
            </Typography>
          )}
        />
      }
    />
  );
};
